import { axios } from "@/client/libs/axios";
import { FilterUserType } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import qs from "qs";
import { ExportXlsx } from "../export-xlsx";
import { useSearchParams } from "react-router";

export const useExportPayment = (filter: string) => {
  const { refetch } = useQuery({
    queryKey: ["Export"],
    queryFn: () => ExportXlsx("payments", filter),
    enabled: false,
  });

  return { refetch };
};
